import React from 'react';
import './index.css';
import { PROFILE_MOBILE_TABS } from '../constants';
import { DetailsCardContainer } from 'views/common-styled-components';
import { useMediaQuery } from 'react-responsive';

const ProfileMobileSection: React.FC = () => {
    const isMobile = useMediaQuery({ maxWidth: 767 });

    return (
        <DetailsCardContainer isMobile={isMobile} className='profileWrapper'>
            <div className="ProfileMenu">
                <ul>
                    {PROFILE_MOBILE_TABS.map((tab, index) => (
                        <li key={index}>
                            <a href={tab.path}>
                                <i className={tab.icon}></i>
                                <p>{tab.title} </p>
                                <i className="icon-arrow_down right-arrow"></i>

                            </a>
                        </li>
                    ))}
                </ul>

            </div>
        </DetailsCardContainer>
    )
}

export default ProfileMobileSection
